import { apiErrorMessage } from '../../lib/api';
import { formatDate, formatNumber } from '../../lib/utils';

// Variante de pastille par état: la couleur dit s'il y a quelque chose à faire.
export const ETAT_VARIANTE = {
  BROUILLON: 'muted',
  A_AFFECTER: 'warning',
  PARTIELLE: 'warning',
  AFFECTEE: 'info',
  EN_ROUTE: 'info',
  LIVREE: 'success',
  ANNULEE: 'muted',
};

const UUID = /^[0-9a-f]{8}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{12}$/i;

// Un texte saisi par l'exploitant (nom de client, lieu, chauffeur) s'affiche tel
// quel, même en majuscules; seuls le vide et un identifiant technique sont
// remplacés par la phrase de repli.
export const libre = (valeur, repli) => {
  const texte = valeur === null || valeur === undefined ? '' : String(valeur).trim();
  if (!texte || texte === 'null' || texte === 'undefined' || UUID.test(texte)) return repli;
  return texte;
};

// Un message du serveur n'est montré que s'il vient d'un refus métier (4xx):
// les erreurs techniques (réseau, 500, 404 générique) sont anglaises ou
// cryptiques, l'opérateur reçoit alors la phrase de repli en français.
export const messageErreur = (error, repli) => {
  const statut = error?.response?.status;
  if (statut >= 400 && statut < 500 && statut !== 404) {
    return libre(apiErrorMessage(error, repli), repli);
  }
  return repli;
};

export const jourLisible = (valeur) => {
  if (!valeur) return 'Non précisée';
  const date = new Date(valeur);
  return Number.isNaN(date.getTime()) ? 'Non précisée' : formatDate(valeur);
};

export const nombreEntier = (valeur) => formatNumber(Math.round(Number(valeur) || 0));

// Part déjà affectée, en pourcentage entier (0 si rien n'est commandé).
export const pourcentAffecte = (progress) => {
  const commande = Number(progress?.ordered_liters) || 0;
  if (commande <= 0) return 0;
  return Math.max(0, Math.min(100, Math.round(((Number(progress?.allocated_liters) || 0) / commande) * 100)));
};
